import { useEffect, useState, useCallback } from "react";
import { useApiConfig } from "./context";
import { getCache, setCache, invalidateCache } from "./cache";

export function useApi<T = any>(url: string, options: RequestInit = {}) {
  const { baseURL, headers, getToken } = useApiConfig();
  const [data, setData] = useState<T | null>(() => getCache(url) || null);
  const [loading, setLoading] = useState(!getCache(url));
  const [error, setError] = useState<any>(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const token = getToken?.();
      const res = await fetch(`${baseURL || ""}${url}`, {
        ...options,
        headers: {
          ...headers,
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      });

      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setCache(url, json);
      setData(json);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [url]);

  useEffect(() => {
    if (!getCache(url)) {
      fetchData();
    }
  }, [url]);

  return {
    data,
    loading,
    error,
    refetch: fetchData,
    invalidate: () => invalidateCache(url),
  };
}
